<template>
  <page-header-wrapper>
    <div class="preview-container">
      <!-- 回到顶部 -->
      <a-back-top>
        <a-button type="primary" shape="circle">
          <a-icon type="up" />
        </a-button>
      </a-back-top>
      <!-- 项目名称 -->
      <a-card :bordered="false">
        <div class="title">
          <a-icon type="container" class="icon" />
          <div class="projectName">项目名称</div>
          <a-badge color="yellow" text="待提交" />
        </div>
        <div style="padding: 10px 0">
          <a-tag>关键词</a-tag>
          <a-tag>关键词</a-tag>
          <a-tag>关键词示例名称</a-tag>
          <a-tag>关键词示例</a-tag>
          <a-tag>关键词</a-tag>
          <a-tag>关键词示例名称</a-tag>
          <a-tag>关键词示例</a-tag>
          <a-tag>关键词示例</a-tag>
          <a-tag>关键词示例名称</a-tag>
        </div>
        <div class="headbtn">
          <a-button @click="Delete">删除</a-button>
          <a-button type="primary" @click="redact"> 编辑 </a-button>
          <a-button type="primary" @click="submit"> 提交 </a-button>
          <a-button @click="sendBack">申请退回</a-button>
          <a-button type="primary" @click="audit"> 审核 </a-button>
          <a-button @click="configuration('examine')">中期检查录入配置</a-button>
          <a-button @click="configuration('evaluate')">绩效评价录入配置</a-button>
          <a-button @click="applyIssue">发布</a-button>
          <a-button @click="applySoldOut">下架</a-button>
          <a-button @click="applySendBack">退回</a-button>
        </div>
        <div class="description">
          <div>项目编号:<span>具体信息</span></div>
          <div>项目类别:<span>具体信息</span></div>
          <div>发布单位:<span>具体信息</span></div>
          <div>项目发布人:<span>具体信息</span></div>
          <div>关联的指南:<span>具体信息</span></div>
          <div>关联的科技需求:<span>具体信息</span></div>
          <div>关注的话题:<span>具体信息</span></div>
          <div>预期成果:<span>具体信息</span></div>
        </div>
        <div class="plan">
          <div class="content">
            <a-icon type="money-collect" />
            <div>
              <div>
                <span>总预算</span>
                <span class="emphasis">34.20万元</span>
              </div>
              <div>
                <span>专项资金</span>
                <span>6.35万元</span>
              </div>
              <div>
                <span>其他来源资金</span>
                <span>17.65万元</span>
              </div>
            </div>
          </div>
          <div class="content">
            <a-icon type="history" />
            <div>
              <div>
                <span>实施周期</span>
                <span class="emphasis">8个月</span>
              </div>
              <div>
                <span>项目周期</span>
                <span>2021-12至2022-08</span>
              </div>
              <div>
                <span>里程碑考核节点</span>
                <span>2022-12</span>
              </div>
            </div>
          </div>
          <div class="content">
            <a-icon type="book" />
            <div>
              <div>
                <span>科技项目成果</span>
                <span class="emphasis">6个</span>
              </div>
              <div>
                <span>科技项目审核通过</span>
                <span>4个</span>
              </div>
            </div>
          </div>
        </div>
      </a-card>
      <!-- 项目联系人信息 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">项目联系人信息</div>
        <div class="content">
          <a-card-grid class="grid-label"> 证件信息 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 联系人姓名 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 所属单位 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 联系电话 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
        </div>
      </a-card>
      <!-- 项目负责人 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">项目负责人信息</div>
        <div class="content">
          <a-card-grid class="grid-label"> 证件信息 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 所属单位 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 姓名 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 性别 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 联系电话 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 出生年月 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 职务 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 最高学历 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 职称 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
          <!--  -->
          <a-card-grid class="grid-label"> 电子邮箱 </a-card-grid>
          <a-card-grid class="grid"> 基本信息 </a-card-grid>
        </div>
      </a-card>
      <!-- 参与单位 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">参与单位</div>
        <div class="content">
          <a-table :pagination="false" bordered :data-source="unitData" :columns="unitColumns">
            <template slot="xmcy" slot-scope="text">
              <div>
                <a @click.prevent="">{{ text }}</a>
              </div>
            </template>
          </a-table>
        </div> 
      </a-card>
      <!-- 参与人员 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">参与人员</div>
        <div class="content">
          <a-table :pagination="false" bordered :data-source="personnelData" :columns="personnelColumns">
            <template slot="ssdw" slot-scope="text">
              <div>
                <a @click.prevent="">{{ text }}</a>
              </div>
            </template>
          </a-table>
        </div>
      </a-card>
      <!-- 项目其他信息 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">项目其他信息</div>
        <div class="content">
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 项目摘要 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%">
              切严而响济外往响满好文海土被改主你写叫消张矿图局感美学整少华展基消做断再以作矿军合教公机命山向治决局。约产间值活进拉类百水据过权走社青技七联行通最委志面更切效来离看完速对复拉即相志市须那史安。成务知产存精专美术那从候议于在很林正一组打情报规层铁物过料回热许证门养儿研来加拉下清往来先连头全候响领米成意月决科并般育写众统常铁光步市酸名所活须花号出。根小连本观六结入们有张示收办声认院公性点并关更便拉带局六变前可千头已收你始水八会对价验例军期清量复相果构天受。
            </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 项目合同 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 其他附件 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
        </div>
      </a-card>

      <!-- 中期检查信息 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">项目其他信息</div>
        <div class="content">
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 中期检查提交时间 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 说明 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%">
              切类养外习直文得工深新证极光务精装线说现直何何江们很克步采研术持又意标他制石么决克成能难气酸下什新问阶日须产长。老认江联置力事领标由解压作则厂产需空风素约条增我飞置也已战五需位难布重干该严参才儿论而你动小发矿省两治类局十。矿业车化领往属也有共员打影实铁工完气些点者号算置通红米土信命们情等斗更极越也边研务想再专高类角验别结为极志主度子大且。
            </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 中期检查报告 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
        </div>
      </a-card>

      <!-- 绩效评价信息 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">绩效评价信息</div>
        <div class="content">
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 绩效评价提交时间 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 说明 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%">
              切类养外习直文得工深新证极光务精装线说现直何何江们很克步采研术持又意标他制石么决克成能难气酸下什新问阶日须产长。老认江联置力事领标由解压作则厂产需空风素约条增我飞置也已战五需位难布重干该严参才儿论而你动小发矿省两治类局十。矿业车化领往属也有共员打影实铁工完气些点者号算置通红米土信命们情等斗更极越也边研务想再专高类角验别结为极志主度子大且。
            </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 绩效自评价报告 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
          <!--  -->
          <div class="grid-wrapper">
            <a-card-grid class="grid-label"> 项目验收材料 </a-card-grid>
            <a-card-grid class="grid" style="width: 80%"> 基本信息 </a-card-grid>
          </div>
        </div>
      </a-card>
      <!-- 科技项目成果录入信息 -->
      <a-card :bordered="false" style="margin-top: 16px">
        <div slot="title" class="grid-title">科技项目成果录入信息</div>
        <div class="content">
          <a-table :pagination="false" bordered :data-source="enteringtData" :columns="enteringColumns">
            <template slot="action" slot-scope="text">
              <div>
                <a @click.prevent="">{{ text }}</a>
              </div>
            </template>
          </a-table>
        </div>
      </a-card>
      <!-- 添加/详情弹框 -->
      <j-modal
        title="项目报备编辑/新增"
        :visible="reportVisible"
        switchFullscreen
        :fullscreen="true"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="关闭"
      >
        <report-modal-list></report-modal-list>
      </j-modal>
      <a-modal v-model="auditVisible" @cancel="auditCancel" @ok="auditOk" width="50%" title="审核">
        <AuditForm></AuditForm>
      </a-modal>
      <a-modal
        v-model="configurationVisible"
        :title="configurationType == 'examine' ? '中期检查录入配置' : '绩效评价录入配置'"
        @cancel="configurationCancel"
        @ok="configurationOk"
        width="50%"
      >
        <ApplyConfiguration :configurationType="configurationType"></ApplyConfiguration>
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
const unitColumns = [
  {
    title: '序号',
    dataIndex: 'serial',
    key: 'serial',
    align: 'center',
    width: 80,
  },
  {
    title: '项目参与单位名称',
    dataIndex: 'xmcy',
    key: 'xmcy',
    align: 'center',
    scopedSlots: { customRender: 'xmcy' },
  },
  {
    title: '单位类型',
    dataIndex: 'dwlx',
    key: 'dwlx',
    align: 'center',
  },
  {
    title: '统一社会信用代码',
    dataIndex: 'xydm',
    key: 'xydm',
    align: 'center',
  },
]

const unitData = [
  {
    serial: 1,
    xmcy: '单位名称',
    dwlx: '单位类型',
    xydm: '统一社会信用代码',
  },
]

const personnelColumns = [
  {
    title: '序号',
    dataIndex: 'serial',
    key: 'serial',
    align: 'center',
    width: 80,
  },
  {
    title: '参与人类型',
    dataIndex: 'cyrlx',
    key: 'cyrlx',
    align: 'center',
  },
  {
    title: '参与人证件信息',
    dataIndex: 'zjxx',
    key: 'zjxx',
    align: 'center',
  },
  {
    title: '参与人姓名',
    dataIndex: 'cyrxm',
    key: 'cyrxm',
    align: 'center',
  },
  {
    title: '参与人所属单位',
    dataIndex: 'ssdw',
    key: 'ssdw',
    align: 'center',
    scopedSlots: { customRender: 'ssdw' },
  },
]

const personnelData = [
  {
    serial: 1,
    cyrlx: '参与人类型',
    zjxx: '参与人证件信息',
    cyrxm: '参与人姓名',
    ssdw: '参与人所属单位',
  },
]

const enteringColumns = [
  {
    title: '序号',
    dataIndex: 'serial',
    key: 'serial',
    align: 'center',
    width: 80,
  },
  {
    title: '成果名称',
    dataIndex: 'cgmc',
    key: 'cgmc',
    align: 'center',
  },
  {
    title: '成果编号',
    dataIndex: 'cgbh',
    key: 'cgbh',
    align: 'center',
  },
  {
    title: '成果类型',
    dataIndex: 'cglx',
    key: 'cglx',
    align: 'center',
  },
  {
    title: '查看成果详情',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]

const enteringtData = [
  {
    serial: 1,
    cgmc: '成果名称',
    cgbh: '成果编号',
    cglx: '成果类型',
    action: '查看成果详情',
  },
]
import ReportModalList from '../components/SubmitList/reportModalList.vue'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import AuditForm from '../components/ApplyList/auditForm.vue'
import ApplyConfiguration from '../components/ApplyList/applyConfiguration.vue'
export default {
  data() {
    return {
      unitColumns: unitColumns,
      unitData: unitData,
      personnelColumns: personnelColumns,
      personnelData: personnelData,
      enteringColumns: enteringColumns,
      enteringtData: enteringtData,
      reportVisible: false,
      auditVisible: false,
      configurationVisible: false,
      configurationType:''
    }
  },
  components: {
    PageHeaderWrapper,
    ReportModalList,
    AuditForm,
    ApplyConfiguration
  },
  methods: {
    //删除项目
    Delete() {
      this.$confirm({
        title: '删除',
        icon: 'exclamation-circle',
        content: (
          <div>
            <p>确定删除？</p>
            <p>删除后将无法列表中查询到此条信息，请谨慎操作。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定删除')
        },
      })
    },
    //提交
    submit() {
      this.$confirm({
        title: '提交',
        icon: 'exclamation-circle',
        content: (
          <div>
            <p>确定提交？</p>
            <p>提交后将无法编辑与删除，需申请退回才可进行修改。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定提交')
        },
      })
    },
    //退回
    sendBack() {
      this.$confirm({
        title: '申请退回',
        icon: 'exclamation-circle',
        content: (
          <div>
            <p>确定申请退回？</p>
            <p>发送申请后需审核人员操作退回才能进行编辑/删除。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定退回')
        },
      })
    },
    //项目审核
    audit() {
      this.auditVisible = true
    },
    //审核页面
    auditCancel() {
      this.auditVisible = false
    },
    //审核页面提交
    auditOk() {
      this.auditCancel()
    },
    //项目编辑
    redact() {
      this.reportVisible = true
    },
    //添加/详情弹框确定按钮
    handleOk() {
      this.reportVisible = false
    },
    //添加/详情弹框取消按钮
    handleCancel() {
      this.reportVisible = false
    },
    //打开配置页面
    configuration(e) {
      if (e == 'examine') {
        //中期检查录入配置页面
        this.configurationType = 'examine'
      } else {
        //绩效评价录入配置页面
        this.configurationType = 'evaluate'
      }
      this.configurationVisible = true
    },
    //关闭配置页面
    configurationCancel() {
      this.configurationVisible = false
    },
    //配置页面提交
    configurationOk() {
      this.configurationCancel()
    },
    //发布项目
    applyIssue() {
      this.$confirm({
        title: '发布',
        icon:'exclamation-circle',
        content: '发布后将进入发布列表，删除/编辑/退回请先下架。',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定发布')
        },
      })
    },
    //下架项目
    applySoldOut() {
      this.$confirm({
        title: '下架',
        icon:'exclamation-circle',
        content: (
          <div>
            <p>确定下架？</p>
            <p>下架后该信息可删除/编辑/退回。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定下架')
        },
      })
    },
    //退回项目
    applySendBack() {
      this.$confirm({
        title: '退回',
        icon:'exclamation-circle',
        content: (
          <div>
            <p>确定退回？</p>
            <p>退回后该信息提交人员即可进行编辑/删除。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定退回')
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  .projectName {
    font-size: 24px;
    font-weight: 600;
    display: inline-block;
    margin: 0 10px;
  }
  .icon {
    color: #1890ff;
    font-size: 24px;
  }
}
.headbtn {
  button {
    margin-right: 10px;
  }
}
.description {
  display: block;
  margin: 2% 8% 2%;
  line-height: 182%;
  font-size: 14px;
  color: #8c8c8c;
  span {
    margin-left: 5px;
    color: rgb(63, 63, 63);
  }
}
.plan {
  display: flex;
  justify-content: space-between;
  .content {
    border: 1px rgb(236, 236, 236) solid;
    width: 33%;
    padding: 15px;
    display: flex;
    i {
      font-size: 20px;
      color: #1890ff;
      margin-right: 10px;
    }
    div {
      width: 100%;
      div {
        display: flex;
        justify-content: space-between;
        span:nth-child(1) {
          color: #8c8c8c;
        }
        span:nth-child(2) {
          font-weight: 600;
        }
        .emphasis {
          font-size: 24px;
          color: #1890ff;
          font-weight: 600;
        }
      }
    }
  }
}
.ant-back-top-inner {
  background: #fff;
  box-shadow: 1px 1px 10px rgba(1, 1, 1, 0.3);
  text-align: center;
  padding: 5px;
}
.preview-container {
  margin-top: 16px;
  .grid-title {
    font-size: 16px;
    font-weight: bold;
    margin: -4px 0;
  }
  .content {
    .grid-wrapper {
      display: flex;
      align-items: stretch;
    }
    // padding: 16px 24px;
    .grid,
    .grid-label {
      width: 30%;
      // height: 40px;
      min-height: 40px;
      // padding: 0;
      text-align: center;
      box-shadow: none;
      border: 1px #e9e9e9 solid;
      // line-height: 40px;
      text-align: left;
      padding: 8px 16px;
      &:hover {
        box-shadow: none;
        border: 1px #e9e9e9 solid;
      }
    }
    .grid-label {
      width: 20%;
      background: #fafafa;
      color: #8c8c8c;
      display: flex;
      align-items: center;
    }
  }
}
</style>